import React, { createContext, useContext, useState, useCallback } from "react";

type AnnouncementContextType = {
  announce: (message: string, callback?: () => void) => void;
};

const AnnouncementContext = createContext<AnnouncementContextType | null>(null);

export const useAnnouncement = (): AnnouncementContextType => {
  const context = useContext(AnnouncementContext);
  if (!context) {
    throw new Error("useAnnouncement must be used inside AnnouncementProvider");
  }
  return context;
};

export const AnnouncementProvider = ({ children }: { children: React.ReactNode }) => {
  const [region1, setRegion1] = useState("");
  const [region2, setRegion2] = useState("");
  const [toggle, setToggle] = useState(false);

  const announce = useCallback((message: string, callback?: () => void) => {
    if (callback) callback();

    if (toggle) {
      setRegion1("");
      setRegion2("");
      setTimeout(() => setRegion1(message), 50);
    } else {
      setRegion2("");
      setRegion1("");
      setTimeout(() => setRegion2(message), 50);
    }

    setToggle(prev => !prev);
  }, [toggle]);

  const liveStyle: React.CSSProperties ={
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    border: 0
  };

  return (
    <AnnouncementContext.Provider value={ { announce } }>
      { children }

      <div aria-live="polite" aria-atomic="true" style={ liveStyle }>
        { region1 }
      </div>

      <div aria-live="polite" aria-atomic="true" style={ liveStyle }>
        { region2 }
      </div>
    </AnnouncementContext.Provider>
  );
};
